import {DataARLedgerModel} from '../../../models/accountsReceivable/data-ar-ledger.model';
import {DataARTransactionItemModel} from '../../../models/accountsReceivable/data-ar-transaction-item.model';
import {DataARPaymentDistribsModel} from '../../../models/accountsReceivable/data-ar-payment-distribs.model';
import { Moment } from 'moment';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';

export class DataARLedgerListModel extends DataARLedgerModel {
  PostedBy: string;
  RunningBalance: number;
  LocationName: string;
  ClientName: string;
  AmountDue: number;
  PaymentsTotal: number;
  dataARTransactionItemList: DataARTransactionItemModel;
  dataARPaymentDistribs: DataARPaymentDistribsModel[] = [];
  NoteCount: number;
  AmountDuePatient: number;
  AmountDueInsurance: number;
  PaymentsTotalPatient: number;
  PaymentsTotalInsurance: number;
  TotalCreditAdjustments: number;
  TotalDebitAdjustments: number;
  DoctorName: string;
  isShowOnLedger: boolean;
  SortColDec: number;
  sortColPostDate: Date;
  isParentTransaction: boolean;
  explanationForVoid: string;
  ARClaimID: string;
  ARClaimIsActive: boolean = false;
  enumClaimStatusID: string;
  // DB ParentLedgerID (ParentLedgerID is overwritten with ARTransactionItemID for charge rows by getLedgerForPatient2)
  OriginalParentLedgerID?: string | null;
  // standalone debit adjustment paid on its own row (interest / late fee), not through a charge
  isPayableAdjustment?: boolean;


  // used on payments page
  ApplyPayment: number;

  // used on debit window
  RefundAmount: number;
  RefundChecked: boolean = true;
  

  ItemDate: Moment;
  enumARPayementTypeID: string;
  
  // For EOB document tracking
  HasEOBDocument: boolean = false;
  EOBDocumentIds: string[] = [];
}

// charges, plus interest / late fee debit adjustments which are paid on their own row
export function isPayableLedgerItem(item: DataARLedgerListModel): boolean {
  return item?.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit
    || (item?.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.DebitAdjustment && item?.isPayableAdjustment === true);
}
